import { createRoot } from "react-dom/client";

import React from 'react';

// Apollo
import { ApolloProvider as ApolloHOCProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/client';
import client from './apollo';

// Router
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import store from './redux/store';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import App from './App';
import { initClarity } from './utils/clarity';

// Stylesheets
import './globals.css';
import 'assets/stylesheets/index.sass';
import { Toaster } from "./components/ui/toast";

// Production guard rail: refuse to boot if a local-emulator endpoint
// is set in a production build. Without this, an accidentally-leaked
// REACT_APP_S3_ENDPOINT in a production build env would silently
// redirect every upload to a sandbox URL with no visible failure
// until somebody noticed missing files. Mirrors the backend guard in
// `config/initializers/aws.rb`. Fires before Sentry init so the trace
// surfaces against a known-bad state, not against downstream symptoms.
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_S3_ENDPOINT) {
  throw new Error(
    'REACT_APP_S3_ENDPOINT is set in a production build. Refusing to boot. ' +
    'Production must use real AWS — unset REACT_APP_S3_ENDPOINT or use a ' +
    'non-production NODE_ENV.'
  );
}

Sentry.init({
  dsn: 'https://4d5b8fcd0a7c4e6cb0a54d69827aa90b@o1199815.ingest.sentry.io/6323689',
  integrations: [new BrowserTracing()],
  tracesSampleRate:  process.env.REACT_APP_SENTRY_TRACE_RATE || 1.0,
  environment: process.env.REACT_APP_ENV || 'development'
});

Sentry.setContext(
  'extra', {
    platform: process.env.REACT_APP_UNIVERSITY === 'DUOC' ? 'DUOC' : 'UC'
  }
);

initClarity();
createRoot(document.getElementById("root")).render(
<ApolloHOCProvider client={client}>
  <ApolloHooksProvider client={client}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </Provider>
  </ApolloHooksProvider>
</ApolloHOCProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
